import { render, staticRenderFns } from "./storagerecord.vue?vue&type=template&id=0069edc0&scoped=true&"
import script from "./storagerecord.vue?vue&type=script&lang=js&"
export * from "./storagerecord.vue?vue&type=script&lang=js&"
import style0 from "./storagerecord.vue?vue&type=style&index=0&id=0069edc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0069edc0",
  null
  
)

export default component.exports